export default {
  '1040C': 'Form 1040 Individual Income Tax Return',
  1065: 'Form 1065 U.S. Return of Partnership Income',
  1120: 'Form 1120 U.S. Corporation Income Tax Return',
  '1120S': 'Form 1120S U.S. Corporation Income Tax Return'
}
